// extracted by mini-css-extract-plugin
module.exports = {"nowrap":"_0fce717cdb--nowrap--QbNay","wrap":"_0fce717cdb--wrap--UqD6F"};